import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import ChangePassWordTab from './ChangePassWordTab';
import { formatDateTimeWithoutHour, getInfomationAccountFromToken } from '../../utils/helper';
import SettingsTab from './SettingsTab';

import { getByIdAccountAction } from '../../store/reducers/account';
import { Get } from '@app/utils/httpProvider';
import { userManager } from '@app/utils/oidc';
import { objectAccountGender } from '@app/utils/define';
import { ACCOUNGINFODUNGCHUNG_API } from '@app/utils/apiUrl';

const Profile = () => {
    const [activeTab, setActiveTab] = useState('SETTINGS');
    const [t] = useTranslation();
    const dispatch = useDispatch();

    const itemAccount = useSelector((state) => state.account.itemAccount);

    const itemAccountAuthInfo = useSelector((state) => state.account.itemAccountAuthInfo);
    const itemAccountInfo = useSelector((state) => state.account.itemAccountInfo);

    console.log('itemAccountInfo', itemAccountInfo);
    console.log('itemAccountAuthInfo', itemAccountAuthInfo);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const renderItems = (items, fields = ['ten', 'name', 'tenDonVi', 'tenChucVu', 'tenChuyenMon']) => {
        if (!Array.isArray(items) || items.length === 0) {
            return <div>Không có dữ liệu</div>;
        }
        return items.map((item, index) => {
            const text = fields
                .map((field) => item?.[field] || item?.[field]?.ten || item?.[field]?.name)
                .find(Boolean);
            return (
                <div key={`item-${index}`}>
                    {text || JSON.stringify(item)}
                </div>
            );
        });
    };

    const renderTrainingItems = (items) => {
        if (!Array.isArray(items) || items.length === 0) {
            return <div>Không có dữ liệu</div>;
        }
        return items.map((item, index) => {
            const text =
                item?.trinhDo?.tenTrinhDo + ' - ' +
                item?.hinhThucDaoTao?.tenHinhThuc + ' - ' +
                item?.nganhDaoTao?.tenNganh + ' - ' +
                formatDateTimeWithoutHour(item?.tuNgay) + ' đến ' +
                formatDateTimeWithoutHour(item?.denNgay) + ' tại ' +
                item?.donViDaoTao?.tenDonViDaoTao;
            renderItems([item], ['ten', 'name'])[0];
            return (
                <div key={`training-${index}`}>
                    {text}
                </div>
            );
        });
    };

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Tài khoản</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('header.label.home')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('views.user.profile')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="card card-primary card-outline">
                                <div className="card-body box-profile">
                                    <div className="text-center">
                                        <img
                                            className="profile-user-img img-fluid img-circle"
                                            src="/img/default-profile.png"
                                            alt="User profile"
                                        />
                                    </div>
                                    <h3 className="profile-username text-center">
                                        {itemAccount
                                            ? itemAccount.username
                                            : ''}
                                    </h3>
                                    <p className="text-muted text-center">
                                        {itemAccount
                                            ? itemAccount.accountAuthInfo?.lastName + ' ' + itemAccount.accountAuthInfo?.middleName + ' ' + itemAccount.accountAuthInfo?.firstName
                                            : ''}
                                    </p>
                                    <ul className="list-group list-group-unbordered mb-3">
                                        <li className="list-group-item">
                                            <b>Tài khoản</b>

                                            <span className="float-right">
                                                {itemAccount
                                                    ? itemAccount.username
                                                    : ''}
                                            </span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Họ tên</b>
                                            <span className="float-right">
                                                {itemAccount
                                                    ? itemAccount.accountAuthInfo?.lastName + ' ' + itemAccount.accountAuthInfo?.middleName + ' ' + itemAccount.accountAuthInfo?.firstName
                                                    : ''}
                                            </span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Email</b>
                                            <span className="float-right">
                                                {itemAccount
                                                    ? itemAccount.accountAuthInfo?.email
                                                    : ''}
                                            </span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Địa chỉ</b>
                                            <span className="float-right">
                                                {itemAccount
                                                    ? itemAccount.accountAuthInfo?.address
                                                    : ''}
                                            </span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Ngày sinh</b>
                                            <span className="float-right">
                                                {itemAccount
                                                    ? itemAccount.accountAuthInfo?.dateOfBirth
                                                        ? new Date(
                                                            itemAccount.accountAuthInfo.dateOfBirth
                                                        ).toLocaleDateString()
                                                        : ''
                                                    : ''}
                                            </span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Giới tính</b>
                                            <span className="float-right">
                                                {itemAccount
                                                    ? objectAccountGender.find(gender => gender.value === itemAccount.accountAuthInfo?.accountGender)?.label
                                                    : ''}
                                            </span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Ngày cấp CCCD</b>
                                            <span className="float-right">
                                                {itemAccount
                                                    ? itemAccount.accountAuthInfo?.issuanceDateOfIdentityCard
                                                        ? new Date(
                                                            itemAccount.accountAuthInfo.issuanceDateOfIdentityCard
                                                        ).toLocaleDateString()
                                                        : ''
                                                    : ''}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="card">
                                <div className="card-header p-2">
                                    <ul className="nav nav-pills">
                                        <li className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-link ${activeTab === 'SETTINGS'
                                                    ? 'active'
                                                    : ''
                                                    }`}
                                                onClick={() =>
                                                    toggle('SETTINGS')
                                                }
                                            >
                                                Cài đặt tài khoản
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-link ${activeTab ===
                                                    'CHANGEPASSWORD'
                                                    ? 'active'
                                                    : ''
                                                    }`}
                                                onClick={() =>
                                                    toggle('CHANGEPASSWORD')
                                                }
                                            >
                                                Đổi mật khẩu
                                            </button>
                                        </li>
                                    </ul>
                                </div>

                                <div className="card-body">
                                    <div className="tab-content">
                                        <SettingsTab
                                            isActive={activeTab === 'SETTINGS'}
                                        />
                                        <ChangePassWordTab
                                            isActive={
                                                activeTab === 'CHANGEPASSWORD'
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="card-body">
                                    <h5>Thông tin bổ sung</h5>
                                    <ul className="list-group list-group-unbordered mb-3">
                                        <li className="list-group-item">
                                            <b>Đơn vị</b>
                                            <div className="float-right text-right">
                                                {renderItems(itemAccountInfo?.donVis, ['tenDonVi', 'name', 'ten'])}
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Chức vụ</b>
                                            <div className="float-right text-right">
                                                {renderItems(itemAccountInfo?.chucVus, ['tenChucVu', 'name', 'ten'])}
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Chuyên môn</b>
                                            <div className="float-right text-right">
                                                {renderItems(itemAccountInfo?.chuyenMons, ['tenChuyenMon', 'name', 'ten'])}
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Quá trình đào tạo</b>
                                            <div className="float-right text-right">
                                                {renderTrainingItems(itemAccountInfo?.quaTrinhDaoTaos)}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Profile;
